import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useCallback, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const MaterialForm = forwardRef(({material, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={material}
      type="material"
      fieldsComponent={(props) => <Fields {...props}/>}
      onSave={useCallback(({name}) => (
        services.material.saveMaterial({...(material?.id ? {id: material.id} : {}), name})
      ), [services, material])}
      onSaved={onSaved}
    />
  );
});

export default MaterialForm;
